/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const setPasswordByInvitationInputDataSchema = z.object({
	invitationToken: z.string(),
	password: z.string(),
})

export type SetPasswordByInvitationInputDataSchema = z.infer<typeof setPasswordByInvitationInputDataSchema>
